import { Button, Layout, message, Row, Space, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LiveProgrammed from "../../../assets/images/live-programmed.webp";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import { ConfirmationModal } from "../../../components/ModalConfirmation";
import ShareModalComponent from "../../../components/ShareModalComponent";
import { getLiveAccesses } from "../../../helpers/constant";
import { deleteLive, getLiveById, getReservations, getTotalPrice } from "../../../redux/lives/livesSlice";
import { AppDispatch, StoreState } from "../../../redux/store";
import { deleteUserCurrentUserEvent } from "../../../redux/users/usersSlice";
import { getPublicEventLink } from "../../../utls/constants";
import { copyToClipboardCustom } from "../../../utls/FunctionsUtil";
import liveUtil from "../../../utls/LiveUtil";
import "./index.less";

const CreatorLiveEventDetailPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const live = useSelector((state: StoreState) => state.lives.item);
  const shouldFetch = useRef(true);
  const [open, setOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState<boolean>(false);

  const accesses = getLiveAccesses(t);

  const handleToggle = () => setOpen(!open);

  const onClickDelete = async () => {
    if (!id) return;
    const result = await dispatch(deleteLive(id));
    if (result.meta.requestStatus === "fulfilled") {
      message.success(t("deleted-live-success"));
      dispatch(deleteUserCurrentUserEvent());
      navigate("/creator/profile");
    }
    handleToggle();
  };

  //TODO : this code needs to be changed and well optimized
  useEffect(() => {
    if (id && shouldFetch.current && !live) {
      shouldFetch.current = false;
      dispatch(getLiveById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (id && live?._id) {
      shouldFetch.current = false;
      dispatch(getReservations(id));
      dispatch(getTotalPrice(id));
    }
  }, [live?._id]);

  const copyLink = async () => {
    if (!id) return;
    const eventLink = getPublicEventLink(id);
    await copyToClipboardCustom(eventLink, t("something-want-wrong"), t("link-successfully-copied")!);
  };

  const shareLink = () => {
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  return (
    <Layout>
      <Layout.Content className="content creatorLiveEventDetailContentWrapper gradient-background-blue">
        <div className="liveProgrammedImg" style={{ backgroundImage: `url(${LiveProgrammed})` }}>
          <ArrowLeftIconComponent />
        </div>
        <Row>
          <Typography.Text className="text-white-color font-32-bold mt-20">{t("scheduled-live")}</Typography.Text>
        </Row>
        <Row>
          <Typography.Text className="text-white-color font-16-regular mt-10">
            {t("the")} {live?.scheduleData?.dateTime && liveUtil.getScheduleDateTime(t, live.scheduleData.dateTime)}
          </Typography.Text>
        </Row>
        <Space size={"middle"} className="mt-30 actionBtnWrapper">
          <Button className={"whiteOutlinedButtonWithRoundedBorder w-full text-white-color"} size={"large"} onClick={copyLink}>
            {t("copy-link")}
          </Button>
          <Button className={"whiteOutlinedButtonWithRoundedBorder w-full text-white-color"} size={"large"} onClick={shareLink}>
            {t("share-link")}
          </Button>
        </Space>
        <Row className="justify-content-around mt-30 gap-14">
          <div className="statWrapper">
            <Typography.Text className="font-28-bold text-white-color">{live?.reservations || 0}</Typography.Text>
            <Typography.Text className="font-12-light text-white-color">{t("ticket-generated")}</Typography.Text>
          </div>
          <div className="statWrapper">
            <Typography.Text className="font-28-bold text-white-color">{live?.amount ?? 0} €</Typography.Text>
            <Typography.Text className="font-12-light text-white-color">{t("price-per-unit")}</Typography.Text>
          </div>
        </Row>
        <Row className="mt-25">
          <Space className="w-full" direction="vertical">
            <Typography.Text className="text-white-color font-32-bold">{t("description")}</Typography.Text>
            <Row className="text-grey-border">
              <Typography.Text className="max-w-206 font-15-regular text-grey-color">{live?.scheduleData?.message || ""}</Typography.Text>
            </Row>
          </Space>
        </Row>
        <Row className="mt-30 mb-40">
          <Button className="liveEventDeleteButton" onClick={handleToggle}>
            {t("delete-event")}
          </Button>
        </Row>
      </Layout.Content>
      <ConfirmationModal
        open={open}
        handleToggle={handleToggle}
        handleConfirm={onClickDelete}
        confBtnMsg={t("modal-confirm-btn")}
        title={t("modal-delete-confirmation-message") + " " + t("fans-will-be-refunded")}
      />
      <ShareModalComponent isOpen={isShareModalOpen} onClose={closeShareModal} link={id ? getPublicEventLink(id) : ""} />
    </Layout>
  );
};

export default CreatorLiveEventDetailPage;
